import { useMemo } from "react";
import { useACLContext, type CheckOptions } from "../context";
import type { Action, EvaluationResult, Resource } from "@shield-acl/core";
import { stableKey } from "./internal";

/**
 * Avaliação detalhada (allowed, reason, matchedRule, scope) — para tooltips,
 * telas de admin e "por que negado".
 */
export function useEvaluate(
  action: Action,
  resource?: Resource,
  opts?: CheckOptions,
): EvaluationResult {
  const { evaluate, user, revision } = useACLContext();
  const key = stableKey(opts);
  return useMemo(
    () => evaluate(action, resource, opts),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [evaluate, action, resource, key, user, revision],
  );
}
